import { useApi } from './useApi';
import { url } from '../../utils/confserveur';
export const useGroupe = (groupeId, enabled,refreshData) => {
  
  const urlfetch = !groupeId ? `${url}groupes/` : `${url}groupes/${groupeId}`;
  
  return useApi(urlfetch, [], refreshData, enabled);
};